import dynamic from 'next/dynamic'
import { useEffect } from 'react'

import useBootstrapData from '@/hooks/useBootstrapData'
import useSeti from '@/hooks/useSeti'
import analytics from '@/shared-utils/analytics'

const FlightsDesktop = dynamic(() => import('./Desktop'))
const FlightsMobile = dynamic(() => import('./Mobile'))

function Flights() {
  useSeti({ experimentCode: 'AA_FLIGHTS_LP' }) // AA Test: Unconditional firing and no visual changes
  useSeti({ experimentCode: 'CG_DIGIOH_FLIGHT_LANDING' })
  const { isMobile } = useBootstrapData()
  useEffect(() => {
    analytics.fireGA4Event({
      event: 'page_view',
      attributes: {
        page_name: 'landing',
        page_desc: 'air',
      },
    })
  }, [])
  return isMobile ? <FlightsMobile /> : <FlightsDesktop />
}

export default Flights
